import { Stack } from 'expo-router'
import { stableStackOptions } from '../../../lib/navigation/stable-stack-options'

export default function MessagesLayout() {
  return (
    <Stack screenOptions={{ headerShown: false, ...stableStackOptions }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="[conversationId]" />
    </Stack>
  )
}
